import "../Performance/Performance.scss";
import "./SingleChannelPage.scss";
import { ButtonFrameworkVariant } from "../Components/ButtonFramework";
import { computeResolvedDate } from "@blisspointmedia/bpm-types/dist/RelativeDatePicker";
import { DailyDeliveryData } from "../StreamingDelivery/StreamingDelivery";
import { DateGroupingKey } from "../TVADCrossChannel/homePageConstants";
import { DateRange, StateSetter, typedReactMemo } from "../utils/types";
import { DeliveryMetricOption } from "./Delivery/SingleChannelDeliveryChart";
import { download } from "../utils/download-utils";
import { DownloadToggle } from "../Components/DownloadDropdown/DownloadToggle";
import { FetchFilterBar, useFilterPaneState } from "./FetchFilterBar/FetchFilterBar";
import { FilterPreset } from "@blisspointmedia/bpm-types/dist/pgTables/FilterPreset";
import { formatPercent } from "../utils/format-utils";
import { GlossaryItem, GlossaryModal } from "../Components/GlossaryModal/GlossaryModal";
import { LiftFromTvChart } from "../Performance/LinearPerformance/LiftFromTvChart";
import { makeColumnMetaData } from "../CrossChannel/crossChannelUtils";
import { MdInfoOutline, MdLink, MdViewHeadline } from "react-icons/md";
import { mediaTypesSelector, useCompanyInfo } from "../redux/company";
import { Metric, MetricTotalsByDate } from "@blisspointmedia/bpm-types/dist/CrossChannel";
import { MetricsTableWithPresets as MetricsTable } from "./MetricsTable/MetricsTableWithPresets";
import { Mixpanel, MxE } from "../utils/mixpanelWrapper";
import { navigate, RouteComponentProps } from "@reach/router";
import { OUTSIDE_RANGE_ERR_MSG } from "@blisspointmedia/bpm-types/dist/FiscalCalendar";
import { ReactComponent as ColorScale } from "./colorScale.svg";
import { TEST_COMPANIES } from "@blisspointmedia/bpm-types/dist/TestCompanies";
import { Tooltip } from "react-bootstrap";
import { useExperimentFlag } from "../utils/experiments/experiment-utils";
import { useMap } from "../utils/hooks/useData";
import { useSelector } from "react-redux";
import { useSetError } from "../redux/modals";
import { validDate } from "../utils/date-utils";
import * as L from "@blisspointmedia/bpm-types/dist/LinearPerformance";
import * as P from "@blisspointmedia/bpm-types/dist/Performance";
import * as R from "ramda";
import * as S from "@blisspointmedia/bpm-types/dist/StreamingPerformance";
import * as UserRedux from "../redux/user";
import * as uuid from "uuid";
import * as Y from "@blisspointmedia/bpm-types/dist/YoutubePerformance";
import CompareMetrics, { CompareMetricOption } from "../CrossChannel/Components/CompareMetrics";
import ConversionLatencyHistogram from "../Performance/StreamingPerformance/ConversionLatencyHistogram";
import Delivery from "./Delivery/Delivery";
import EditPagePresetModal from "./MetricsTableConfig/EditPagePresetModal";
import EditTablePresetModal from "./MetricsTableConfig/EditTablePresetModal";
import MatchableRates from "../Performance/StreamingPerformance/MatchableRates";
import PerformanceGridSkeleton from "../Performance/PerformanceGridSkeleton";
import PresetDropdown from "./PresetDropdown";
import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import RenameModal from "./RenameModal";
import SparkChart from "../Components/SparkChart/SparkChart";
import useLocation from "../utils/hooks/useLocation";
import {
  awaitJSON,
  LinearPerformanceLambdaFetch,
  SingleChannelLambdaFetch,
} from "../utils/fetch-utils";
import {
  CellData,
  ColumnMetaData,
  ColumnMetaDataMap,
  convertDBCustomMetric,
  convertKPIMapToOptions,
  DimensionMap,
  Formatter,
  joinMetricsTableData,
  toPrettyCPX,
  toPrettySpend,
} from "./MetricsTable/metricsTableUtils";
import {
  Column,
  DEFAULT_DATE_RANGE_STATE,
  DEFAULT_OTHER_DATE_RANGE_STATE,
  DeletePresetParams as DeleteTablePresetParams,
  DimensionColumn,
  GetPresetParams as GetTablePresetParams,
  LINEAR,
  MetricsTablePreset,
  PresetIDGroups,
  SavePresetParams as SaveTablePresetParams,
  SEARCHSHOPPING,
  STREAMING_PLUS,
  SuperHeader,
  YOUTUBE,
} from "@blisspointmedia/bpm-types/dist/MetricsTable";
import {
  DateInfo,
  DeletePresetParams as DeletePagePresetParams,
  GlobalOptions,
  MetricsPagePreset,
  SavePresetParams as SavePagePresetParams,
} from "@blisspointmedia/bpm-types/dist/MetricsPage";
import {
  ALL_GROUP_NAME,
  decodePrettyUrl,
  encodePrettyUrl,
  getBaseURL,
  getGlobalBrand,
  PerformanceContext,
  SingleChannelMediaTypes,
  STANDARD_GROUP_NAME,
} from "../Performance/performanceUtils";
import {
  BPMButton,
  Button,
  ButtonType,
  DatePicker,
  Dropdown,
  DropdownToggleType,
  FilterBar,
  FullPageSpinner,
  OverlayTrigger,
  Page,
  Spinner,
  useKpiPickerData,
} from "../Components";
import {
  computeCustomRelativeRange,
  computeDateFromComparisonPreset,
  computeDateFromPreset,
} from "@blisspointmedia/bpm-types/dist/RelativeDatePresets";
import {
  HeatMappingDivergent0,
  HeatMappingDivergentNeg1,
  HeatMappingDivergentNeg2,
  HeatMappingDivergentNeg3,
  HeatMappingDivergentPos1,
  HeatMappingDivergentPos2,
  HeatMappingDivergentPos3,
} from "../utils/colors";
import {
  GetCustomMetricsParams,
  GetCustomMetricsResponse,
} from "@blisspointmedia/bpm-types/dist/CustomMetrics";

const enum TabKey {
  DELIVERY = "delivery",
  METRICS_TABLE = "metrics-table",
  OVERVIEW = "overview",
}

const NAVS = [
  { label: "Overview", key: TabKey.OVERVIEW },
  { label: "Metrics Table", key: TabKey.METRICS_TABLE },
  { label: "Delivery", key: TabKey.DELIVERY },
];

export const DATE_GROUPING_MAP: Record<
  "daily" | "weekly" | "monthly" | "quarterly" | "yearly",
  DateGroupingKey
> = {
  daily: "Day",
  weekly: "Week",
  monthly: "Month",
  quarterly: "Quarter",
  yearly: "Year",
};

const DEFAULT_SPARK_CHART_METRICS_MAP = {
  clicks: "clicks",
  cpm: "cpm",
  cpx: "cpx",
  impressions: "impressions",
  revenue: "revenue",
  roas: "roas",
  spend: "spend",
  volume: "volume",
};

interface SingleChannelPageProps extends RouteComponentProps {
  columnMetaDataMap: ColumnMetaDataMap;
  dataFetchKey: (args) => string;
  dateIncrementOptions?: ("daily" | "weekly" | "monthly" | "quarterly" | "yearly")[];
  dates: DateRange;
  defaultKPI?: string;
  defaultLag?: S.LagOption;
  defaultSparkChartMetrics?: string[];
  defaultCompareMetrics?: [string, string];
  defaultDeliveryOverviewMetrics?: [string, string, string];
  deletePagePreset: (params: DeletePagePresetParams) => Promise<void>;
  deleteTablePreset: (params: DeleteTablePresetParams) => Promise<void>;
  deliveryDimensionMap: Record<string, string>;
  deliveryMetricOptions?: DeliveryMetricOption[];
  dimensionColumnMetaDataMap: ColumnMetaDataMap;
  fetchingPagePresets: boolean;
  fetchingTablePresets: boolean;
  filterData: P.GetFilterOptionsResponse;
  filterDataProcessor?: (data: P.GetFilterOptionsResponse, ...args) => P.GetFilterOptionsResponse;
  getDeliveryData: (params) => Promise<DailyDeliveryData>;
  getPerformanceData: (
    params,
    extra
  ) => Promise<S.GetPageDataResponse & L.GetPageDataResponse & Y.GetPageDataResponse>;
  getDimensionCell: (
    dimensionData: DimensionMap,
    dimensionHeader: DimensionColumn,
    ...args: any[]
  ) => CellData;
  getTablePreset: (params: GetTablePresetParams) => Promise<MetricsTablePreset | undefined>;
  glossary?: GlossaryItem[];
  isGraph?: boolean;
  kpiMetaData: P.GetKpiMetaDataResponse;
  pagePresets: MetricsPagePreset[];
  percentAOIPlaceholder?: number;
  prefix: SingleChannelMediaTypes;
  savePagePreset: (body: Partial<SavePagePresetParams>) => Promise<{ id: number; name: string }>;
  saveTablePreset: (body: Partial<SaveTablePresetParams>) => Promise<{ id: number; name: string }>;
  setDates: StateSetter<DateRange>;
  setPagePresets: StateSetter<MetricsPagePreset[] | undefined>;
  setTablePresets: StateSetter<MetricsTablePreset[] | undefined>;
  sparkChartMetricPrettyNameMap?: Record<string, string>;
  sparkChartMetricsMap: Record<string, string>;
  tablePresets: PresetIDGroups[];
  updateSettings?: (args) => void;
  urlSettings: string;
  useCrossChannelKpis?: boolean;
}

const SingleChannelPage = typedReactMemo<React.FC<SingleChannelPageProps>>(
  ({
    columnMetaDataMap: standardColumnMetaDataMap = {},
    dataFetchKey,
    dateIncrementOptions = ["daily", "weekly", "monthly", "quarterly", "yearly"],
    dates,
    defaultKPI,
    defaultLag,
    defaultSparkChartMetrics = ["spend", "impressions", "volume", "roas"],
    defaultCompareMetrics,
    defaultDeliveryOverviewMetrics,
    deletePagePreset,
    deleteTablePreset,
    deliveryDimensionMap = {},
    deliveryMetricOptions: standardDeliveryMetricOptions,
    dimensionColumnMetaDataMap = {},
    fetchingPagePresets,
    fetchingTablePresets,
    filterData,
    filterDataProcessor = (filterData, ...args) => filterData,
    getDeliveryData,
    getDimensionCell,
    getPerformanceData,
    getTablePreset,
    glossary = [],
    isGraph,
    kpiMetaData,
    location,
    pagePresets,
    percentAOIPlaceholder,
    prefix,
    savePagePreset,
    saveTablePreset,
    setDates,
    setPagePresets,
    setTablePresets,
    sparkChartMetricPrettyNameMap = {},
    sparkChartMetricsMap = DEFAULT_SPARK_CHART_METRICS_MAP,
    tablePresets,
    updateSettings = () => {},
    urlSettings,
    useCrossChannelKpis = false,
  }) => {
    const [branchBuild] = useState("v2/latest");
    const shouldEnableProgrammaticPages = useExperimentFlag("enableUseTTDProgramatic");
    const shouldEnableEmailScp = useExperimentFlag("enableEmailScp");

    const [customColumnMetaDataMap, setCustomColumnMetaDataMap] = useState<
      Record<string, ColumnMetaData>
    >();
    const [dataMap, setDataMap] = useMap<string, S.GetPageDataResponse | undefined>();
    const [dataStatusMap, setDataStatusMap] = useMap<string, string | undefined>();
    const [deliveryDataMap, setDeliveryDataMap] = useMap<string, any>();
    const [deliveryDataStatusMap, setDeliveryDataStatusMap] = useMap<string, string | undefined>();
    const [deliveryDimension, setDeliveryDimension] = useState<string>(
      R.keys(deliveryDimensionMap)[0]
    );

    const [exportedData, setExportedData] = useState<(string | number)[][]>([]);
    const [filter, setFilter] = useState<{ filter: (line: Record<string, any>) => boolean }>();
    const [filterID, setFilterID] = useState<number | undefined>();
    const [filters, setFilters] = useState<FilterPreset[]>();
    const [filterSource, setFilterSource] = useState<
      "presetFilterID" | "currentFilterID" | "presetState" | "currentState"
    >();
    const [filterState, setFilterState, resetFilterState] = useFilterPaneState();
    const [loading, setLoading] = useState<boolean>(false);
    const [otherDates, setOtherDates] = useState<DateRange>();
    const [pageGroupName, setPageGroupName] = useState<string>("");
    const [pagePresetChanges, setPagePresetChanges] = useState<MetricsPagePreset>({
      globalOptions: {},
    } as MetricsPagePreset);
    const [pagePresetName, setPagePresetName] = useState<string>();
    const [tablePresetName, setTablePresetName] = useState<string>();
    const [pickerAudience, setPickerAudience] = useState<L.Audience>();
    const [pickerKPI, setPickerKPI] = useState<string>("");
    const [pickerLag, setPickerLag] = useState<S.LagOption>();
    const [rerenderTable, setRerenderTable] = useState(false);
    const [saving, setSaving] = useState(false);
    const [selectedTab, setSelectedTab] = useState<string>();
    const [showColorScale, setShowColorScale] = useState<boolean>(false);
    const [showEditPagePresetModal, setShowEditPagePresetModal] = useState<boolean>(false);
    const [showEditTablePresetModal, setShowEditTablePresetModal] = useState<boolean>(false);
    const [showGlossary, setShowGlossary] = useState<boolean>(false);
    const [showNewPagePresetModal, setShowNewPagePresetModal] = useState<boolean>(false);
    const [showNewTablePresetModal, setShowNewTablePresetModal] = useState<boolean>(false);
    const [showRenamePagePresetModal, setShowRenamePagePresetModal] = useState<boolean>(false);
    const [showRenameTablePresetModal, setShowRenameTablePresetModal] = useState<boolean>(false);
    const [tableHeight, setTableHeight] = useState(250);
    const [tablePresetChanges, setTablePresetChanges] = useState<MetricsTablePreset>(
      {} as MetricsTablePreset
    );
    const [tablePresetMap, setTablePresetMap] = useMap<string, MetricsTablePreset | undefined>();
    const [tableWidth, setTableWidth] = useState(500);
    const [showMetricsTableComparison, setShowMetricsTableComparison] = useState<boolean>(false);
    const { company } = useLocation();
    const companyInfo = useCompanyInfo();
    const fiscalCal = useMemo(() => companyInfo.fiscal_cal || {}, [companyInfo]);
    const containerRef = useRef(null);
    const isAdmin = useSelector(UserRedux.isAdminSelector);
    const mediaTypes = useSelector(mediaTypesSelector(company));
    const pagePresetURLString = "_page-preset=";
    const setError = useSetError();
    const tablePresetURLString = "_table-preset=";

    const columnMetaDataMap = useMemo(
      () => ({
        ...standardColumnMetaDataMap,
        ...R.defaultTo({}, customColumnMetaDataMap),
      }),

      [customColumnMetaDataMap, standardColumnMetaDataMap]
    );

    const deliveryMetricOptions = useMemo(() => {
      if (standardDeliveryMetricOptions && customColumnMetaDataMap) {
        const deliveryMetricOptions = standardDeliveryMetricOptions;
        const availableMetrics = R.map(
          (option: DeliveryMetricOption) => option.value,
          R.defaultTo([], deliveryMetricOptions)
        );
        for (const dataVarName of R.keys(customColumnMetaDataMap)) {
          const colMetaData = customColumnMetaDataMap[dataVarName];
          if (
            colMetaData &&
            colMetaData.requiredTotalsColumns &&
            colMetaData.requiredTotalsColumns.length
          ) {
            for (const metric of colMetaData.requiredTotalsColumns) {
              if (!availableMetrics.includes(metric as string)) {
                return deliveryMetricOptions;
              }
            }
            deliveryMetricOptions.push({
              isCustom: true,
              isSpend: [toPrettyCPX, toPrettySpend].includes(
                customColumnMetaDataMap[dataVarName].formatValue as Formatter
              ),
              fetchGetter: customColumnMetaDataMap[dataVarName].fetchGetter,
              label: customColumnMetaDataMap[dataVarName].displayName,
              value: dataVarName,
            });
          }
        }
        return deliveryMetricOptions;
      }
    }, [customColumnMetaDataMap, standardDeliveryMetricOptions]);

    const compareMetricOptions = useMemo(() => {
      const compareMetricOptions: CompareMetricOption[] = R.map(
        key => ({
          label: R.defaultTo(sparkChartMetricsMap[key], sparkChartMetricPrettyNameMap[key]),
          value: key as any,
        }),
        R.keys(sparkChartMetricsMap)
      );
      if (compareMetricOptions && customColumnMetaDataMap) {
        for (const dataVarName of R.keys(customColumnMetaDataMap)) {
          const colMetaData = customColumnMetaDataMap[dataVarName];
          if (
            colMetaData &&
            colMetaData.requiredTotalsColumns &&
            colMetaData.requiredTotalsColumns.length
          ) {
            compareMetricOptions.push({
              isCustom: true,
              fetchGetter: customColumnMetaDataMap[dataVarName].fetchGetter,
              label: customColumnMetaDataMap[dataVarName].displayName,
              value: dataVarName as Metric,
            });
          }
        }
        return compareMetricOptions;
      }
    }, [customColumnMetaDataMap, sparkChartMetricsMap, sparkChartMetricPrettyNameMap]);

    const mediaTypeEnabled = useMemo(
      () =>
        TEST_COMPANIES.includes(company) ||
        mediaTypes.includes(prefix === LINEAR ? "tv" : prefix) ||
        (prefix === "programmatic" && shouldEnableProgrammaticPages) ||
        (prefix === "email" && shouldEnableEmailScp),
      [company, mediaTypes, prefix, shouldEnableProgrammaticPages, shouldEnableEmailScp]
    );
    const baseUrl = useMemo(() => {
      return getBaseURL(urlSettings, location);
    }, [urlSettings, location]);

    const [startingDateRange, startingOtherDateRange] = useMemo(() => {
      const localDateRangeString = localStorage.getItem(`${company}_${prefix}PerfDateRange`);
      const localDateRange = localDateRangeString ? JSON.parse(localDateRangeString) : null;
      const localOtherDateRangeString = localStorage.getItem(
        `${company}_${prefix}OtherPerfDateRange`
      );
      const localOtherDateRange = localOtherDateRangeString
        ? JSON.parse(localOtherDateRangeString)
        : null;
      return [
        {
          start:
            localDateRange && localDateRange.start
              ? localDateRange.start
              : computeResolvedDate(DEFAULT_DATE_RANGE_STATE.start),
          end:
            localDateRange && localDateRange.end
              ? localDateRange.end
              : computeResolvedDate(DEFAULT_DATE_RANGE_STATE.end),
        },
        {
          start:
            localOtherDateRange && localOtherDateRange.start
              ? localOtherDateRange.start
              : computeResolvedDate(DEFAULT_OTHER_DATE_RANGE_STATE.start),
          end:
            localOtherDateRange && localOtherDateRange.end
              ? localOtherDateRange.end
              : computeResolvedDate(DEFAULT_OTHER_DATE_RANGE_STATE.end),
        },
      ];
    }, [company, prefix]);

    const resetPickers = useCallback(() => {
      setDates(undefined as any);
      setFilterSource(undefined);
      setOtherDates(undefined as any);
      setPickerAudience("" as any);
      setPickerKPI("");
      setPickerLag("" as any);
    }, [setDates]);

    const setURL = useCallback(
      (pagePresetName: string, tablePresetName?: string, selectedTabInput?: string) => {
        // To avoid infinite renders, only update the URL and page preset if it's different from
        // the current state
        const newURL = `${location?.origin}${baseUrl}/${R.defaultTo(
          selectedTab,
          selectedTabInput
        )}${pagePresetURLString}${encodePrettyUrl(pagePresetName)}${
          tablePresetName ? `${tablePresetURLString}${encodePrettyUrl(tablePresetName)}` : ""
        }`;
        const isLocationDifferent = location && location.href !== newURL;
        if (selectedTab && isLocationDifferent) {
          setPagePresetName(pagePresetName);
          setTablePresetName(tablePresetName);
          navigate(newURL);
          Mixpanel.track(MxE.PAGE_PRESET_CHANGE, {
            option_selected: pagePresetName,
          });
        }
      },
      [location, baseUrl, selectedTab]
    );

    const [tablePreset, tablePresetID] = useMemo(() => {
      if (tablePresetName && tablePresets && tablePresetMap && customColumnMetaDataMap) {
        const tablePresetID = R.find(preset => preset.name === tablePresetName, tablePresets);
        if (tablePresetID) {
          return [tablePresetMap[`${tablePresetID?.id}`], tablePresetID.id];
        }
      }
      return [undefined, undefined];
    }, [customColumnMetaDataMap, tablePresetMap, tablePresetName, tablePresets]);

    const pagePreset = useMemo(() => {
      if (pagePresets && tablePresets && !fetchingPagePresets && !fetchingTablePresets) {
        const foundPagePreset = R.find(
          (preset: MetricsPagePreset) => preset.name === pagePresetName,
          pagePresets
        );
        if (foundPagePreset) {
          const pagePreset = R.clone(foundPagePreset);
          const pagePresetChanges = R.clone(foundPagePreset);
          // Set Filter Info
          if (pagePreset.filterInfo && R.isNil(filterSource)) {
            if (!R.isNil(pagePreset.filterInfo.filterID)) {
              setFilterSource("presetFilterID");
              setFilterID(pagePreset.filterInfo.filterID);
            } else if (pagePreset.filterInfo.filterState) {
              setFilterSource("presetState");
              setFilterState(pagePreset.filterInfo.filterState);
            } else {
              setFilterSource("currentState");
              resetFilterState();
            }
          } else {
            pagePresetChanges.filterInfo = {};
            if (filterID) {
              pagePresetChanges.filterInfo.filterID = filterID;
            } else if (filterState) {
              pagePresetChanges.filterInfo.filterState = filterState;
            }
          }
          // Set Global Options
          if (pagePreset.globalOptions) {
            if (!pickerAudience) {
              const audience = pagePreset?.globalOptions.audience || "HH";
              setPickerAudience(audience);
            } else {
              (pagePresetChanges.globalOptions as GlobalOptions).audience = pickerAudience;
            }
            if (!pickerKPI) {
              const kpi =
                pagePreset.globalOptions.kpi ||
                defaultKPI ||
                (useCrossChannelKpis
                  ? companyInfo.cross_channel_kpis[0]
                  : companyInfo.streaming_performance_default_kpi);
              setPickerKPI(kpi);
              (pagePresetChanges.globalOptions as GlobalOptions).kpi = kpi;
            } else {
              (pagePresetChanges.globalOptions as GlobalOptions).kpi = pickerKPI;
            }
            if (!pickerLag) {
              const lag =
                pagePreset.globalOptions.lag ||
                defaultLag ||
                companyInfo.streaming_performance_default_lag;
              setPickerLag(lag);
              (pagePresetChanges.globalOptions as GlobalOptions).lag = lag;
            } else {
              (pagePresetChanges.globalOptions as GlobalOptions).lag = pickerLag;
            }
          } else {
            pagePresetChanges.globalOptions = {} as GlobalOptions;
            if (pickerKPI) {
              (pagePresetChanges.globalOptions as GlobalOptions).kpi = pickerKPI;
            }
            if (pickerAudience) {
              (pagePresetChanges.globalOptions as GlobalOptions).audience = pickerAudience;
            }
            if (pickerLag) {
              (pagePresetChanges.globalOptions as GlobalOptions).lag = pickerLag;
            }
          }
          // Set Dates
          if (pagePreset.dateInfo) {
            const {
              start,
              end,
              dateType,
              relative_date_info,
              comparison_start,
              comparison_end,
              comparison_dateType,
              comparison_relative_date_info,
            } = pagePreset.dateInfo;
            let resolvedPrimaryDates: DateRange | undefined;
            let resolvedComparisonDates: DateRange | undefined;
            // Set Primary Dates
            if (dateType === "relative" && relative_date_info && relative_date_info !== "Custom") {
              try {
                if (typeof relative_date_info === "string") {
                  const newRange = computeDateFromPreset(relative_date_info, fiscalCal);
                  resolvedPrimaryDates = newRange;
                } else {
                  const newRange = computeCustomRelativeRange(
                    relative_date_info.start,
                    relative_date_info.end,
                    fiscalCal
                  );
                  resolvedPrimaryDates = newRange;
                }
              } catch {
                console.error(OUTSIDE_RANGE_ERR_MSG);
              }
            } else if (start && end) {
              resolvedPrimaryDates = {
                start: start,
                end: end,
              };
            }
            if (resolvedPrimaryDates) {
              pagePreset.dateInfo = pagePreset.dateInfo = {
                ...R.defaultTo({}, pagePreset.dateInfo),
                ...resolvedPrimaryDates,
              } as DateInfo;
            } else {
              setDates(startingDateRange);
              pagePreset.dateInfo = pagePreset.dateInfo = {
                ...R.defaultTo({}, pagePreset.dateInfo),
                ...startingDateRange,
              } as DateInfo;
            }
            if (R.isNil(dates)) {
              setDates(pagePreset.dateInfo);
              pagePresetChanges.dateInfo = pagePreset.dateInfo;
            } else {
              pagePresetChanges.dateInfo = pagePresetChanges.dateInfo = {
                ...R.defaultTo({}, pagePresetChanges.dateInfo),
                ...dates,
              } as DateInfo;
            }
            /// Set Comparison Dates
            if (
              comparison_dateType === "relative" &&
              comparison_relative_date_info &&
              comparison_relative_date_info !== "Custom" &&
              resolvedPrimaryDates
            ) {
              if (typeof comparison_relative_date_info === "string") {
                try {
                  const newRange = computeDateFromComparisonPreset(
                    comparison_relative_date_info,
                    resolvedPrimaryDates.start,
                    resolvedPrimaryDates.end,
                    fiscalCal
                  );
                  resolvedComparisonDates = newRange;
                } catch {
                  console.error(OUTSIDE_RANGE_ERR_MSG);
                }
              } else {
                try {
                  const newRange = computeCustomRelativeRange(
                    comparison_relative_date_info.start,
                    comparison_relative_date_info.end,
                    fiscalCal
                  );
                  resolvedComparisonDates = newRange;
                } catch {
                  console.error(OUTSIDE_RANGE_ERR_MSG);
                }
              }
            } else if (comparison_start && comparison_end) {
              resolvedComparisonDates = {
                start: comparison_start,
                end: comparison_end,
              };
            }
            if (!resolvedComparisonDates) {
              resolvedComparisonDates = startingOtherDateRange;
            }
            pagePreset.dateInfo = {
              ...pagePreset.dateInfo,
              comparison_start: resolvedComparisonDates.start,
              comparison_end: resolvedComparisonDates.end,
            } as DateInfo;
            if (R.isNil(otherDates)) {
              setOtherDates({
                start: pagePreset.dateInfo.comparison_start as string,
                end: pagePreset.dateInfo.comparison_end as string,
              });
              pagePresetChanges.dateInfo = pagePreset.dateInfo;
            } else {
              pagePresetChanges.dateInfo = pagePresetChanges.dateInfo = {
                ...R.defaultTo({}, pagePresetChanges.dateInfo),
                comparison_start: otherDates.start,
                comparison_end: otherDates.end,
              } as DateInfo;
            }
          } else {
            if (R.isNil(dates)) {
              setDates(startingDateRange);
              pagePresetChanges.dateInfo = {
                ...R.defaultTo({}, pagePresetChanges.dateInfo),
                ...startingDateRange,
              } as DateInfo;
            }
            if (R.isNil(otherDates)) {
              setOtherDates(startingOtherDateRange);
              pagePresetChanges.dateInfo = {
                ...R.defaultTo({}, pagePresetChanges.dateInfo),
                comparison_start: startingOtherDateRange.start,
                comparison_end: startingOtherDateRange.end,
              } as DateInfo;
            }
          }
          // Set Table Preset
          if (R.isNil(tablePresetID) && tablePresetMap && pagePreset.globalOptions) {
            const pageSourcedTableID = pagePreset.globalOptions.tableID;
            const pageSourcedTablePreset = R.find(
              preset => preset.id === pageSourcedTableID,
              tablePresets
            );
            if (pageSourcedTablePreset) {
              setURL(pagePreset.name, pageSourcedTablePreset.name);
            } else if (tablePresets && tablePresets.length) {
              for (const tablePreset of tablePresets) {
                if (!tablePreset.temporary) {
                  pagePreset.globalOptions.tableID = tablePreset.id;
                  (pagePresetChanges.globalOptions as GlobalOptions).tableID = tablePreset.id;
                  setURL(pagePreset.name, tablePreset.name);
                  break;
                }
              }
            }
          } else if (!R.isNil(tablePresetID)) {
            (pagePresetChanges.globalOptions as GlobalOptions).tableID = tablePresetID;
          }
          // Set Delivery Dimension
          if (pagePreset.globalOptions && pagePreset.globalOptions.deliveryDimension) {
            setDeliveryDimension(pagePreset.globalOptions.deliveryDimension);
          }
          setPagePresetChanges(pagePresetChanges as MetricsPagePreset);
          return pagePreset;
        }
      }
    }, [
      companyInfo,
      dates,
      defaultKPI,
      defaultLag,
      fetchingPagePresets,
      fetchingTablePresets,
      filterID,
      filterSource,
      filterState,
      otherDates,
      pagePresetName,
      pagePresets,
      pickerAudience,
      pickerKPI,
      pickerLag,
      resetFilterState,
      setDates,
      setFilterState,
      setURL,
      startingDateRange,
      startingOtherDateRange,
      tablePresetID,
      tablePresetMap,
      tablePresets,
      useCrossChannelKpis,
      fiscalCal,
    ]);

    const pagePresetGroups = useMemo(() => {
      const groupsMap = {};
      if (pagePresets) {
        for (const preset of pagePresets) {
          if (preset.presetGroup && preset.presetGroup !== STANDARD_GROUP_NAME) {
            groupsMap[preset.presetGroup] = true;
          }
        }
      }
      return R.keys(groupsMap).sort();
    }, [pagePresets]);

    // These global options can come from the pickers, page preset, or default company settings
    // Order of importance would be pickers > page preset > company settings
    const [fetchAudience, fetchKPI, fetchLag, globalBrand] = useMemo(() => {
      const defAudience: L.Audience = "HH";
      const defKpi = R.defaultTo(companyInfo.streaming_performance_default_kpi, defaultKPI);
      const defLag: S.LagOption = R.defaultTo(
        companyInfo.streaming_performance_default_lag,
        defaultLag
      );
      const { audience: presetAudience, kpi: presetKPI, lag: presetLag } =
        pagePreset && pagePreset.globalOptions
          ? pagePreset.globalOptions
          : {
              audience: undefined,
              kpi: undefined,
              lag: undefined,
            };
      return [
        pickerAudience ? pickerAudience : presetAudience ? presetAudience : defAudience,
        pickerKPI ? pickerKPI : presetKPI ? presetKPI : defKpi,
        pickerLag ? pickerLag : presetLag ? presetLag : defLag,
        getGlobalBrand(
          companyInfo,
          R.defaultTo(defAudience, R.defaultTo(presetAudience, pickerAudience))
        ),
      ];
    }, [companyInfo, defaultKPI, defaultLag, pagePreset, pickerAudience, pickerKPI, pickerLag]);

    const fetchKey = useMemo(() => {
      if (
        pagePreset &&
        dates &&
        branchBuild &&
        (fetchKPI || useCrossChannelKpis) &&
        fetchLag &&
        fetchAudience &&
        !R.isNil(tablePresetID)
      ) {
        const customFilterState =
          filterSource === "currentState" ? `_${JSON.stringify(filterState)}` : "";
        const customFilterSettings =
          filterState && pagePreset.filterInfo.filterState
            ? R.equals(filterState, pagePreset.filterInfo.filterState)
            : false;
        return `${pagePreset.id}_${dates.start}_${dates.end}_${branchBuild}_${fetchKPI}_${fetchLag}_${fetchAudience}_${filterID}_${tablePresetID}_${selectedTab}_${customFilterSettings}_${deliveryDimension}${customFilterState}`;
      }
      return "";
    }, [
      branchBuild,
      dates,
      deliveryDimension,
      fetchAudience,
      fetchKPI,
      fetchLag,
      filterID,
      filterSource,
      filterState,
      pagePreset,
      selectedTab,
      tablePresetID,
      useCrossChannelKpis,
    ]);

    const otherFetchKey = useMemo(() => {
      if (
        pagePreset &&
        otherDates &&
        branchBuild &&
        (fetchKPI || useCrossChannelKpis) &&
        fetchLag &&
        fetchAudience &&
        !R.isNil(tablePresetID)
      ) {
        const customFilterState =
          filterSource === "currentState" ? `_${JSON.stringify(filterState)}` : "";
        const customFilterSettings =
          filterState && pagePreset.filterInfo.filterState
            ? R.equals(filterState, pagePreset.filterInfo.filterState)
            : false;
        return `${pagePreset.id}_${otherDates.start}_${otherDates.end}_${branchBuild}_${fetchKPI}_${fetchLag}_${fetchAudience}_${filterID}_${tablePresetID}_${selectedTab}_${customFilterSettings}_${deliveryDimension}${customFilterState}`;
      }
      return "";
    }, [
      branchBuild,
      deliveryDimension,
      fetchAudience,
      fetchKPI,
      fetchLag,
      filterID,
      filterSource,
      filterState,
      otherDates,
      pagePreset,
      selectedTab,
      tablePresetID,
      useCrossChannelKpis,
    ]);

    const data = dataMap[fetchKey];
    const otherData = dataMap[otherFetchKey];
    const deliveryData = deliveryDataMap[fetchKey];
    const otherDeliveryData = deliveryDataMap[otherFetchKey];

    useEffect(() => {
      updateSettings({
        pagePreset,
        pickerAudience,
        pickerKPI,
        pickerLag,
        setPickerAudience,
        setPickerKPI,
        setPickerLag,
        setTablePresetName,
        tablePreset,
      });
    }, [pagePreset, pickerAudience, pickerKPI, pickerLag, tablePreset, updateSettings]);

    useEffect(() => {
      if (R.isNil(selectedTab)) {
        if (urlSettings.startsWith(TabKey.DELIVERY)) {
          setSelectedTab(TabKey.DELIVERY);
        } else if (urlSettings.startsWith(TabKey.METRICS_TABLE)) {
          setSelectedTab(TabKey.METRICS_TABLE);
        } else if (urlSettings.startsWith(TabKey.OVERVIEW)) {
          setSelectedTab(TabKey.OVERVIEW);
        } else {
          setSelectedTab(TabKey.OVERVIEW);
        }
      }
    }, [selectedTab, urlSettings]);

    useEffect(() => {
      if (
        selectedTab &&
        pagePresets &&
        pagePresets.length &&
        tablePresets &&
        tablePresets.length &&
        !fetchingPagePresets &&
        !fetchingTablePresets &&
        !pagePresetName // We want to only use this logic when we load up the page
      ) {
        const decodedURLPagePresetName = decodePrettyUrl(
          urlSettings.substring(
            selectedTab.length + pagePresetURLString.length,
            urlSettings.indexOf(tablePresetURLString) >= 0
              ? urlSettings.indexOf(tablePresetURLString)
              : urlSettings.length
          )
        );
        const decodedURLTablePresetName = decodePrettyUrl(
          urlSettings.substring(
            urlSettings.indexOf(tablePresetURLString) + tablePresetURLString.length,
            urlSettings.length
          )
        );
        if (R.isNil(tablePresetName) && decodedURLTablePresetName) {
          setTablePresetName(decodedURLTablePresetName);
        }
        if (R.isNil(pagePresetName) && decodedURLPagePresetName) {
          setPagePresetName(decodedURLPagePresetName);
        }
        const urlPagePreset = R.find(
          preset => preset.name === decodedURLPagePresetName,
          pagePresets
        );
        const urlTablePreset = R.find(
          preset => preset.name === decodedURLTablePresetName,
          tablePresets
        );
        if (
          R.isNil(urlPagePreset) ||
          R.isNil(urlTablePreset) ||
          (pagePreset && pagePreset.name !== urlPagePreset.name)
        ) {
          if (urlPagePreset) {
            setURL(urlPagePreset.name, urlTablePreset?.name);
            if (urlPagePreset.presetGroup && urlPagePreset.presetGroup.length > 0) {
              setPageGroupName(urlPagePreset.presetGroup);
            } else {
              setPageGroupName(ALL_GROUP_NAME);
            }
          } else if (pagePresets && pagePresets.length) {
            for (const preset of pagePresets) {
              if (!preset.temporary) {
                setURL(preset.name, urlTablePreset?.name);
                setPageGroupName(R.defaultTo(ALL_GROUP_NAME, preset.presetGroup));
                break;
              }
            }
          }
        }
      }
    }, [
      fetchingPagePresets,
      fetchingTablePresets,
      pageGroupName,
      pagePreset,
      pagePresetName,
      pagePresets,
      selectedTab,
      setURL,
      tablePreset,
      tablePresetName,
      tablePresets,
      urlSettings,
    ]);

    useEffect(() => {
      if (
        !R.isNil(tablePresetID) &&
        !tablePreset &&
        pagePreset &&
        tablePresetMap &&
        R.map(preset => preset.id, R.defaultTo([], tablePresets) as PresetIDGroups[]).includes(
          tablePresetID
        )
      ) {
        (async () => {
          try {
            const tablePreset = await getTablePreset({
              id: tablePresetID,
              company,
              mediatype: prefix,
            });
            if (tablePreset) {
              setTablePresetMap(`${tablePresetID}`, tablePreset);
              setTablePresetChanges(tablePreset);
              setURL(pagePreset.name, tablePreset.name);
            }
          } catch (e) {
            const error = e as Error;
            setError({
              reportError: error,
              message: error.message,
            });
          }
        })();
      } else if (pagePreset && tablePresetMap[`${tablePresetID}`]) {
        setURL(pagePreset.name, (tablePresetMap[`${tablePresetID}`] as MetricsTablePreset).name);
      }
    }, [
      setError,
      company,
      prefix,
      companyInfo,
      startingDateRange,
      tablePreset,
      getTablePreset,
      setTablePresetMap,
      pagePreset,
      tablePresets,
      tablePresetMap,
      setURL,
      tablePresetName,
      tablePresetID,
    ]);

    const onDatePickerChange = useCallback(
      (dates: DateRange) => {
        localStorage.setItem(`${company}_${prefix}PerfDateRange`, JSON.stringify(dates));
        setDates(dates);
      },
      [company, prefix, setDates]
    );

    const onOtherDatePickerChange = useCallback(
      (otherDates: DateRange) => {
        localStorage.setItem(`${company}_${prefix}OtherPerfDateRange`, JSON.stringify(otherDates));
        setOtherDates(otherDates);
      },
      [company, prefix, setOtherDates]
    );

    const resetDefaultDates = useCallback(() => {
      localStorage.removeItem(`${company}_${prefix}PerfDateRange`);
      localStorage.removeItem(`${company}_${prefix}otherPerfDateRange`);
      setDates({
        start: computeResolvedDate(DEFAULT_DATE_RANGE_STATE.start),
        end: computeResolvedDate(DEFAULT_DATE_RANGE_STATE.end),
      });
      setOtherDates({
        start: computeResolvedDate(DEFAULT_DATE_RANGE_STATE.start),
        end: computeResolvedDate(DEFAULT_DATE_RANGE_STATE.end),
      });
    }, [company, prefix, setDates]);

    // Delivery Data
    const fetchDeliveryData = useCallback(
      (key, dates) => {
        (async () => {
          try {
            setLoading(true);
            let params: any = {
              agency: companyInfo.agency,
              company,
              dates,
              dimension: deliveryDimensionMap[deliveryDimension],
              filterState: {
                advanced: "",
                basic: { notMap: {}, selectedMap: {} },
                isAdvanced: false,
              },
              prefix,
              // The following params are used for the new Single Channel delivery lambda. Will probably
              // refactor this once we have all channels using it.
              channel: prefix,
              start: dates?.start,
              end: dates?.end,
              pageID: 0, // use this param so that lambdas knows to use the right test company for single channel
            };
            if (fetchKPI) {
              params.kpi = fetchKPI;
            }
            if (fetchAudience) {
              params.audience = fetchAudience;
            }
            // We don't want to check for the filter state if we don't have a preset and
            // if we haven't loaded the filter state from the page/filter preset
            if (filterSource === "currentState" && !R.isNil(filterState)) {
              params.filterState = filterState;
            } else if (filterSource === "currentFilterID" && !R.isNil(filterID)) {
              params.filterID = filterID;
            } else if (
              pagePreset &&
              filterSource === "presetFilterID" &&
              !R.isNil(pagePreset.filterInfo.filterID)
            ) {
              params.filterID = pagePreset.filterInfo.filterID;
            } else if (
              pagePreset &&
              filterSource === "presetState" &&
              pagePreset.filterInfo.filterState
            ) {
              params.filterState = pagePreset.filterInfo.filterState;
            }
            const data = await getDeliveryData(params);
            setDeliveryDataMap(key, data);
          } catch (e) {
            setDeliveryDataStatusMap(key, "readyToFetch");
            const error = e as Error;
            setError({
              reportError: error,
              message: error.message,
            });
          } finally {
            setLoading(false);
          }
        })();
      },
      [
        company,
        companyInfo.agency,
        deliveryDimension,
        deliveryDimensionMap,
        fetchAudience,
        fetchKPI,
        filterID,
        filterSource,
        filterState,
        getDeliveryData,
        pagePreset,
        prefix,
        setDeliveryDataMap,
        setDeliveryDataStatusMap,
        setError,
      ]
    );

    useEffect(() => {
      if (
        selectedTab === TabKey.DELIVERY &&
        fetchKey &&
        deliveryDataStatusMap[fetchKey] === "readyToFetch"
      ) {
        if (R.isNil(deliveryDataMap[fetchKey])) {
          try {
            fetchDeliveryData(fetchKey, dates);
          } catch (e) {
            console.error(
              `Failed to fetch delivery data for ${company}, ${fetchKey}, ${dates}. Refresh to retry`
            );
            setDeliveryDataStatusMap(fetchKey, "failed");
          }
        }
        setDeliveryDataStatusMap(fetchKey, "fetched");
      }
    }, [
      company,
      dataMap,
      dataStatusMap,
      dates,
      deliveryDataMap,
      deliveryDataStatusMap,
      fetchDeliveryData,
      fetchKey,
      selectedTab,
      setDataStatusMap,
      setDeliveryDataStatusMap,
    ]);

    useEffect(() => {
      if (
        selectedTab === TabKey.DELIVERY &&
        otherFetchKey &&
        deliveryDataStatusMap[otherFetchKey] === "readyToFetch"
      ) {
        if (R.isNil(deliveryDataMap[otherFetchKey])) {
          try {
            fetchDeliveryData(otherFetchKey, otherDates);
          } catch (e) {
            console.error(
              `Failed to fetch delivery data for ${company}, ${otherFetchKey}, ${otherDates}. Refresh to retry`
            );
            setDeliveryDataStatusMap(otherFetchKey, "failed");
          }
        }
        setDeliveryDataStatusMap(otherFetchKey, "fetched");
      }
    }, [
      company,
      dataMap,
      dataStatusMap,
      deliveryDataMap,
      deliveryDataStatusMap,
      fetchDeliveryData,
      otherDates,
      otherFetchKey,
      selectedTab,
      setDataStatusMap,
      setDeliveryDataStatusMap,
    ]);

    useEffect(() => {
      if (fetchKey && R.isNil(deliveryDataStatusMap[fetchKey]) && !deliveryData) {
        setDeliveryDataStatusMap(fetchKey, "readyToFetch");
      }
    }, [
      branchBuild,
      company,
      data,
      dataStatusMap,
      dates,
      deliveryData,
      deliveryDataStatusMap,
      fetchDeliveryData,
      fetchKey,
      fetchKPI,
      fetchLag,
      setDataMap,
      setDataStatusMap,
      setDeliveryDataStatusMap,
      setError,
    ]);

    useEffect(() => {
      if (otherFetchKey && R.isNil(deliveryDataStatusMap[otherFetchKey]) && !otherDeliveryData) {
        setDeliveryDataStatusMap(otherFetchKey, "readyToFetch");
      }
    }, [
      branchBuild,
      company,
      data,
      dataStatusMap,
      dates,
      deliveryDataStatusMap,
      fetchDeliveryData,
      fetchKey,
      fetchKPI,
      fetchLag,
      otherData,
      otherDeliveryData,
      otherFetchKey,
      setDataMap,
      setDataStatusMap,
      setDeliveryDataStatusMap,
      setError,
    ]);

    // Performance Data
    const fetchPerformanceData = useCallback(
      (key, dates) => {
        (async () => {
          try {
            setLoading(true);
            const [branch, build] = branchBuild.split("/");
            let params: any = {
              ...(dates || {}),
              pageID: R.defaultTo({ id: 0 }, pagePreset).id,
              company,
              branch,
              build,
              filterID,
              id: 0, // TODO: remove this
              tableID: tablePresetID,
              mediatype: prefix,
              channel: prefix,
            };
            if (fetchKPI) {
              params.kpi = fetchKPI;
            }
            if (fetchLag) {
              params.lag = fetchLag;
            }
            if (fetchAudience) {
              params.audience = fetchAudience;
            }
            if (!R.isNil(pagePreset) && !R.isNil(pagePreset.globalOptions)) {
              if (!R.isNil(tablePresetID) && tablePresetID !== pagePreset.globalOptions.tableID) {
                params.tableID = tablePresetID;
              }
              if (pagePreset.globalOptions.shouldUseUnequivalizedImpressions) {
                params.shouldUseUnequivalizedImpressions =
                  pagePreset.globalOptions.shouldUseUnequivalizedImpressions;
              }
            }
            // We don't want to check for the filter state if we don't have a preset and
            // if we haven't loaded the filter state from the page/filter preset
            if (filterSource === "currentState" && !R.isNil(filterState)) {
              params.filterState = JSON.stringify(filterState);
            } else if (filterSource === "currentFilterID" && !R.isNil(filterID)) {
              params.filterID = filterID;
            }
            if (selectedTab === TabKey.OVERVIEW) {
              params.byDate = "dateOnly";
            }
            const data = await getPerformanceData(params, { tablePreset });
            setDataMap(key, data);
            if (selectedTab === TabKey.METRICS_TABLE) {
              setLoading(false);
            }
          } catch (e) {
            setDataStatusMap(key, "readyToFetch");
            const error = e as Error;
            setError({
              reportError: error,
              message: error.message,
            });
            setLoading(false);
          } finally {
            setRerenderTable(true);
          }
        })();
      },
      [
        branchBuild,
        company,
        fetchAudience,
        fetchKPI,
        fetchLag,
        filterID,
        filterSource,
        filterState,
        getPerformanceData,
        pagePreset,
        prefix,
        selectedTab,
        setDataMap,
        setDataStatusMap,
        tablePreset,
        tablePresetID,
        setError,
      ]
    );

    useEffect(() => {
      if (
        (selectedTab === TabKey.OVERVIEW ||
          (selectedTab === TabKey.METRICS_TABLE && !R.isNil(tablePreset))) &&
        fetchKey &&
        dataStatusMap[fetchKey] === "readyToFetch"
      ) {
        if (R.isNil(dataMap[fetchKey])) {
          try {
            fetchPerformanceData(fetchKey, dates);
          } catch (e) {
            console.error(
              `Failed to fetch performance data for ${company}, ${fetchKey}, ${dates}. Refresh to retry`
            );
            setDataStatusMap(fetchKey, "failed");
          }
        }
        setDataStatusMap(fetchKey, "fetched");
      }
    }, [
      company,
      dataMap,
      dataStatusMap,
      dates,
      fetchPerformanceData,
      fetchKey,
      setDataStatusMap,
      selectedTab,
      tablePreset,
    ]);

    useEffect(() => {
      if (
        (selectedTab === TabKey.OVERVIEW ||
          (selectedTab === TabKey.METRICS_TABLE && !R.isNil(tablePreset))) &&
        otherFetchKey &&
        dataStatusMap[otherFetchKey] === "readyToFetch"
      ) {
        if (R.isNil(dataMap[otherFetchKey])) {
          try {
            fetchPerformanceData(otherFetchKey, otherDates);
          } catch (e) {
            console.error(
              `Failed to fetch performance data for ${company}, ${otherFetchKey}, ${otherDates}. Refresh to retry`
            );
            setDataStatusMap(otherFetchKey, "failed");
          }
        }
        setDataStatusMap(otherFetchKey, "fetched");
      }
    }, [
      company,
      dataMap,
      dataStatusMap,
      fetchPerformanceData,
      otherDates,
      otherFetchKey,
      selectedTab,
      setDataStatusMap,
      tablePreset,
    ]);

    useEffect(() => {
      if (fetchKey && R.isNil(dataStatusMap[fetchKey]) && !data) {
        setDataStatusMap(fetchKey, "readyToFetch");
      }
    }, [
      branchBuild,
      company,
      data,
      dataStatusMap,
      dates,
      fetchPerformanceData,
      fetchKey,
      fetchKPI,
      fetchLag,
      setDataMap,
      setDataStatusMap,
      setError,
    ]);

    useEffect(() => {
      if (otherFetchKey && R.isNil(dataStatusMap[otherFetchKey]) && !otherData) {
        setDataStatusMap(otherFetchKey, "readyToFetch");
      }
    }, [
      branchBuild,
      company,
      data,
      dataStatusMap,
      dates,
      fetchPerformanceData,
      fetchKey,
      fetchKPI,
      fetchLag,
      otherData,
      otherFetchKey,
      setDataMap,
      setDataStatusMap,
      setError,
    ]);

    const getCustomMetrics = useCallback(() => {
      (async () => {
        const customMetricsResp = await SingleChannelLambdaFetch<GetCustomMetricsParams>(
          "/getCustomMetrics",
          {
            params: {
              company,
              channel: prefix,
            },
          }
        );
        const customMetrics = await awaitJSON<GetCustomMetricsResponse>(customMetricsResp);
        const customColumnMetaDataMap: Record<string, ColumnMetaData> = {};
        for (const metric of customMetrics) {
          const convertedMetric = convertDBCustomMetric(metric);
          if (convertedMetric) {
            customColumnMetaDataMap[metric.name] = convertedMetric;
          }
        }
        setCustomColumnMetaDataMap(customColumnMetaDataMap);
      })();
    }, [company, prefix]);

    useEffect(() => {
      (async () => {
        if (R.isNil(customColumnMetaDataMap)) {
          await getCustomMetrics();
        }
      })();
    }, [customColumnMetaDataMap, getCustomMetrics]);

    const copyURLToClipboard = useCallback((url: string) => {
      const el = window.document.createElement("textarea");
      el.value = url;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      window.document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      alert(`Copied new link to clipboard: ${url}`);
    }, []);

    const savePagePresetToDB = useCallback(
      async (newPagePreset: MetricsPagePreset, copyLink = false) => {
        if (newPagePreset) {
          if (!newPagePreset.temporary && newPagePreset.name === "") {
            setError({
              title: "Blank Name",
              message: "Your view must have a name.",
            });
            return;
          }
          setSaving(true);
          let body: SavePagePresetParams = {
            company: globalBrand || company,
            companyToUseInDB: company,
            group: newPagePreset.presetGroup,
            id: newPagePreset.id ? newPagePreset.id : "new",
            mediatype: prefix,
            name: newPagePreset.name,
            preset: newPagePreset,
            temporary: newPagePreset.temporary,
          };
          try {
            const { id, message, name } = (await savePagePreset(body)) as any;
            if (message) {
              throw new Error(message);
            }
            const newURL = `${location?.origin}${baseUrl}/${pagePresetURLString}${encodePrettyUrl(
              name
            )}`;
            if (pagePreset && newPagePreset.id === pagePreset.id) {
              navigate && navigate(newURL);
            }
            if (window && window.document && copyLink) {
              copyURLToClipboard(newURL);
            }
            if (
              (pagePreset && newPagePreset.id === pagePreset.id) ||
              body.id === "new" ||
              body.id <= 0
            ) {
              setPagePresetChanges(newPagePreset);
              setURL(name);
            }
            setDataMap(fetchKey, undefined);
            setDataStatusMap(fetchKey, undefined);
            setPagePresets(presets => [
              ...R.defaultTo([], presets),
              {
                ...newPagePreset,
                id,
                name,
                temporary: Boolean(body.temporary),
              },
            ]);
          } catch (e) {
            const error = e as Error;
            setError({
              title: "Couldn't save view",
              message: error.message,
              reportError: error,
            });
          } finally {
            setSaving(false);
          }
        }
      },
      [
        globalBrand,
        company,
        prefix,
        setError,
        savePagePreset,
        location?.origin,
        baseUrl,
        pagePreset,
        setURL,
        setDataMap,
        fetchKey,
        setDataStatusMap,
        setPagePresets,
        copyURLToClipboard,
      ]
    );

    ////////////////////////////
    // PAGE CONTROLS
    ////////////////////////////
    const shareButton = (
      <OverlayTrigger
        overlay={<Tooltip id={uuid.v4()}>Copy link to current view</Tooltip>}
        placement="bottom center"
      >
        <Button
          icon={<MdLink />}
          size={"lg"}
          type={ButtonType.FILLED}
          variant={ButtonFrameworkVariant.ICON_ONLY}
          onClick={() => {
            if (
              pagePreset &&
              tablePreset &&
              R.equals(pagePreset, pagePresetChanges) &&
              pagePreset.globalOptions &&
              pagePreset.globalOptions.tableID === tablePreset.id &&
              R.equals(tablePreset, tablePresetChanges) &&
              pagePreset.filterInfo &&
              pagePreset.filterInfo.filterID === filterID &&
              location
            ) {
              const url = location.href;
              copyURLToClipboard(url);
            } else {
              savePagePresetToDB(
                {
                  ...pagePresetChanges,
                  company,
                  id: "new" as any,
                  mediatype: prefix,
                  temporary: true,
                },
                true
              );
            }
          }}
        />
      </OverlayTrigger>
    );
    const pagePresetPicker = (
      <PresetDropdown
        addPresetOnClick={() => {
          setShowNewPagePresetModal(true);
          // In the case that we are in the standard group already, clear this out
          setPagePresetChanges(
            preset =>
              ({
                ...preset,
                id: "new",
                name: "New Page Preset!",
                presetGroup: "",
                dateInfo: {
                  ...preset.dateInfo,
                  dateType: "relative",
                  comparison_dateType: "relative",
                  relative_date_info: "Last Month",
                  comparison_relative_date_info: "Default",
                },
              } as any)
          );
        }}
        addPresetText={"Add New Page Preset"}
        applyOnClick={preset => {
          setURL(preset.name);
          resetPickers();
        }}
        cancelOnClick={() => {}}
        className={`pagePresetPicker ${fetchingPagePresets ? "loading" : ""}`}
        defaultPresetNames={["Default"]}
        deleteItemOnClick={presetID => deletePagePreset({ id: presetID, mediatype: prefix })}
        duplicateItemOnClick={preset =>
          savePagePreset({
            company,
            id: "new",
            mediatype: prefix,
            preset: preset,
            name: `${preset.name} (Copy)`,
            group: preset.presetGroup,
          })
        }
        editItemOnClick={preset => {
          const presetCopy = { ...preset };
          if (
            preset.dateInfo &&
            preset.dateInfo.dateType === "relative" &&
            !preset.dateInfo.relative_date_info
          ) {
            presetCopy.dateInfo.dateType = "exact";
          }
          if (preset.dateInfo && !preset.dateInfo.comparison_relative_date_info) {
            presetCopy.dateInfo.comparison_dateType = "exact";
          }
          setPagePresetChanges(presetCopy);
          setShowEditPagePresetModal(true);
        }}
        hasPresetGroups={true}
        hasTicks={true}
        label={
          pagePreset && !R.isNil(pagePreset.id)
            ? `Page Preset: ${pagePreset.temporary ? "Temp" : pagePreset.name}`
            : "Load Page Preset"
        }
        presets={R.filter(
          preset => !preset.temporary || (!R.isNil(pagePreset) && preset.id === pagePreset.id),
          pagePresets
        )}
        renameItemOnClick={preset => {
          setPagePresetChanges(preset);
          setShowRenamePagePresetModal(true);
        }}
        selectedPreset={pagePreset}
        subTitles={["Preset Group", "Preset"]}
      />
    );

    const kpiData = useKpiPickerData({
      company,
      mediaType: prefix,
      useCrossChannelKpis,
      useTestParams: true,
    });
    const kpiOptions = useMemo(() => {
      const kpiOptions: {
        label: string;
        value: string;
        customContent?: JSX.Element;
      }[] = convertKPIMapToOptions(prefix, R.defaultTo({ kpiMap: {} }, kpiData).kpiMap);
      for (const option of kpiOptions) {
        if (kpiMetaData[option.value]) {
          const { info } = kpiMetaData[option.value] as P.KpiMetaData & { info: string };
          if (info) {
            option.customContent = (
              <OverlayTrigger
                overlay={<Tooltip id={uuid.v4()}>{info}</Tooltip>}
                placement="bottom left"
              >
                <div className="kpiInfoTooltip">
                  <MdInfoOutline />
                </div>
              </OverlayTrigger>
            );
          }
        }
      }
      return R.sortBy(R.prop("label"), R.uniq(kpiOptions));
    }, [kpiData, kpiMetaData, prefix]);

    const pickerKPIName = useMemo(() => {
      const kpiOption = R.find(option => option.value === pickerKPI, kpiOptions);
      return kpiOption ? kpiOption.label : "";
    }, [kpiOptions, pickerKPI]);

    const kpiPicker = (
      <Dropdown
        background="dark"
        label="KPI"
        onChange={option => {
          Mixpanel.track(MxE.PAGE_KPI_CHANGE, {
            option_selected: option,
          });
          setPickerKPI(option);
        }}
        options={kpiOptions}
        size="lg"
        type={DropdownToggleType.OUTLINED}
        value={pickerKPI}
      />
    );
    // When we are using an amazon sales performance KPI on streaming or are on commerce, the only
    // lag we offer is 14d
    const lagPicker = ["audio", "display", "olv", "streaming", "commerce"].includes(prefix) && (
      <Dropdown
        background="dark"
        label="Lag"
        onChange={setPickerLag}
        options={R.filter(
          lag =>
            (prefix !== "commerce" &&
              ![S.getAmazonTransactionsKPI(company), S.getAmazonTransactionsKPI(company)].includes(
                pickerKPI
              )) ||
            lag === "14d",
          S.LAGS
        )}
        size="lg"
        type={DropdownToggleType.OUTLINED}
        value={fetchLag}
      />
    );
    const audiencePicker = prefix === LINEAR && (
      <Dropdown
        background="dark"
        label="Audience"
        onChange={setPickerAudience}
        options={L.AUDIENCES}
        size="lg"
        type={DropdownToggleType.OUTLINED}
        value={fetchAudience}
      />
    );

    const actionsContainer = (
      <div className="performanceActions performanceTitle">
        {shareButton}
        {pagePresetPicker}
        {kpiPicker}
        {lagPicker}
        {audiencePicker}
        {localStorage.getItem(`${company}_${prefix}PerfDateRange`) && (
          <BPMButton size="sm" onClick={resetDefaultDates}>
            Reset Default Dates
          </BPMButton>
        )}
        <DatePicker
          range={dates}
          onChange={onDatePickerChange}
          datePresets={true}
          comparison={true}
          comparisonRange={otherDates}
          comparisonOnChange={onOtherDatePickerChange}
        />
      </div>
    );

    const subHeader = pagePreset && (
      <FetchFilterBar
        categories={filterDataProcessor(
          filterData,
          tablePreset,
          deliveryDimension,
          selectedTab,
          pickerKPI
        )}
        company={company}
        filterID={filterID}
        filters={filters}
        filterSource={filterSource}
        platform={prefix}
        refreshData={() => {
          setDataMap(fetchKey, undefined);
          setDataStatusMap(fetchKey, "readyToFetch");
          setDataStatusMap(otherFetchKey, "readyToFetch");
          setDeliveryDataMap(fetchKey, undefined);
          setDeliveryDataStatusMap(fetchKey, "readyToFetch");
          setDeliveryDataStatusMap(otherFetchKey, "readyToFetch");
        }}
        setFilterID={setFilterID}
        setFilters={setFilters}
        setFilterSource={
          setFilterSource as StateSetter<
            "presetFilterID" | "currentFilterID" | "presetState" | "currentState"
          >
        }
        setState={setFilterState}
        state={filterState}
      />
    );

    ////////////////////////////
    // OVERVIEW TAB
    ////////////////////////////
    const [overviewData, otherOverviewData] = useMemo(() => {
      const overviewData: MetricTotalsByDate[] = [];
      const otherOverviewData: MetricTotalsByDate[] = [];
      // We will use this to extract data from the fetch, since we don't have an actual column,
      // use all global values.
      const fakeColumn = { audience: fetchAudience, kpi: fetchKPI, lag: fetchLag };
      if (
        selectedTab === TabKey.OVERVIEW &&
        data &&
        data.data &&
        otherData &&
        otherData.data &&
        customColumnMetaDataMap
      ) {
        for (const row of data.data) {
          const metrics = {
            clicks: 0,
            clicksConversionRate: 0,
            cpc: 0,
            cpm: 0,
            cpx: 0,
            ctr: 0,
            impressions: 0,
            impressionShare: 0,
            impsConversionRate: 0,
            revenue: 0,
            roas: 0,
            spend: 0,
            spots: 0,
            topImpressionShare: 0,
            volume: 0,
          };
          for (const metric of R.keys(sparkChartMetricsMap)) {
            if (!overviewData[metric]) {
              overviewData[metric] = [];
            }
            const fetchKey = dataFetchKey(fakeColumn);
            if (
              row.fetches &&
              row.fetches[fetchKey] &&
              !R.isNil((row.dimensions as any).Date) &&
              validDate((row.dimensions as any).Date)
            ) {
              const metricValue =
                columnMetaDataMap[sparkChartMetricsMap[metric]] &&
                columnMetaDataMap[sparkChartMetricsMap[metric]].fetchGetter
                  ? columnMetaDataMap[sparkChartMetricsMap[metric]].fetchGetter(
                      row.fetches[fetchKey]
                    )
                  : row.fetches[fetchKey][sparkChartMetricsMap[metric]];
              metrics[metric] = metricValue === "--" ? 0 : metricValue;
            }
          }
          for (const metric of R.keys(customColumnMetaDataMap)) {
            if (!overviewData[metric]) {
              overviewData[metric] = [];
            }
            const fetchKey = dataFetchKey(fakeColumn);
            if (
              row.fetches &&
              row.fetches[fetchKey] &&
              !R.isNil((row.dimensions as any).Date) &&
              validDate((row.dimensions as any).Date)
            ) {
              const metricValue =
                columnMetaDataMap[metric] && columnMetaDataMap[metric].fetchGetter
                  ? columnMetaDataMap[metric].fetchGetter(row.fetches[fetchKey])
                  : row.fetches[fetchKey][metric];
              metrics[metric] = metricValue === "--" ? 0 : metricValue;
            }
          }
          overviewData.push({
            date: (row.dimensions as any).Date,
            metrics,
          } as MetricTotalsByDate);
        }
        for (const row of otherData.data) {
          const metrics = {
            clicks: 0,
            clicksConversionRate: 0,
            cpc: 0,
            cpm: 0,
            cpx: 0,
            ctr: 0,
            impressions: 0,
            impressionShare: 0,
            impsConversionRate: 0,
            revenue: 0,
            roas: 0,
            spend: 0,
            spots: 0,
            topImpressionShare: 0,
            volume: 0,
          };
          for (const metric of R.keys(sparkChartMetricsMap)) {
            if (!otherOverviewData[metric]) {
              otherOverviewData[metric] = [];
            }
            const fetchKey = dataFetchKey(fakeColumn);
            if (
              row.fetches &&
              row.fetches[fetchKey] &&
              !R.isNil((row.dimensions as any).Date) &&
              validDate((row.dimensions as any).Date)
            ) {
              const metricValue =
                columnMetaDataMap[sparkChartMetricsMap[metric]] &&
                columnMetaDataMap[sparkChartMetricsMap[metric]].fetchGetter
                  ? columnMetaDataMap[sparkChartMetricsMap[metric]].fetchGetter(
                      row.fetches[fetchKey]
                    )
                  : row.fetches[fetchKey][sparkChartMetricsMap[metric]];
              metrics[metric] = metricValue === "--" ? 0 : metricValue;
            }
          }
          for (const metric of R.keys(customColumnMetaDataMap)) {
            if (!otherOverviewData[metric]) {
              otherOverviewData[metric] = [];
            }
            const fetchKey = dataFetchKey(fakeColumn);
            if (
              row.fetches &&
              row.fetches[fetchKey] &&
              !R.isNil((row.dimensions as any).Date) &&
              validDate((row.dimensions as any).Date)
            ) {
              const metricValue =
                columnMetaDataMap[metric] && columnMetaDataMap[metric].fetchGetter
                  ? columnMetaDataMap[metric].fetchGetter(row.fetches[fetchKey])
                  : row.fetches[fetchKey][metric];
              metrics[metric] = metricValue === "--" ? 0 : metricValue;
            }
          }
          otherOverviewData.push({
            date: (row.dimensions as any).Date,
            metrics,
          } as MetricTotalsByDate);
        }
        const sortedOverviewData = R.sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
          overviewData
        );
        const sortedOtherOverviewData = R.sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
          otherOverviewData
        );
        setLoading(false);
        return [sortedOverviewData, sortedOtherOverviewData];
      }
      return [undefined, undefined];
    }, [
      columnMetaDataMap,
      customColumnMetaDataMap,
      data,
      dataFetchKey,
      fetchAudience,
      fetchKPI,
      fetchLag,
      otherData,
      selectedTab,
      sparkChartMetricsMap,
    ]);

    const overviewSparkCharts = useMemo(() => {
      let index = -1;
      const metricOptions = R.map(
        key => ({
          label: R.defaultTo(sparkChartMetricsMap[key], sparkChartMetricPrettyNameMap[key]),
          value: key as any,
        }),
        R.keys(sparkChartMetricsMap)
      );
      if (customColumnMetaDataMap) {
        for (const dataVarName of R.keys(R.defaultTo({}, customColumnMetaDataMap))) {
          metricOptions.push({
            label: customColumnMetaDataMap[dataVarName].displayName,
            value: dataVarName,
          });
        }
      }
      return (
        pagePresetChanges &&
        pagePresetChanges.globalOptions &&
        customColumnMetaDataMap && (
          <div className="overviewSparkCharts">
            {R.filter(
              chart => !R.isNil(chart),
              R.map(metric => {
                index = index + 1;
                if (overviewData && otherOverviewData) {
                  return (
                    <SparkChart
                      data={overviewData}
                      defaultMetric={metric}
                      key={metric}
                      otherData={otherOverviewData}
                      metricOptions={metricOptions}
                    />
                  );
                } else {
                  return undefined;
                }
              }, R.defaultTo(defaultSparkChartMetrics, pagePresetChanges.globalOptions.sparkCharts) as Metric[])
            )}
          </div>
        )
      );
    }, [
      customColumnMetaDataMap,
      defaultSparkChartMetrics,
      otherOverviewData,
      overviewData,
      pagePresetChanges,
      sparkChartMetricPrettyNameMap,
      sparkChartMetricsMap,
    ]);

    const overviewCompareMetricsChart = overviewData && otherOverviewData && compareMetricOptions && (
      <div className="overviewCompareMetricsChart">
        <CompareMetrics
          data={overviewData}
          dates={dates}
          otherData={otherOverviewData}
          otherDates={otherDates}
          defaultMetrics={
            pagePresetChanges &&
            pagePresetChanges.globalOptions &&
            pagePresetChanges.globalOptions &&
            pagePresetChanges.globalOptions.compareMetrics
              ? pagePresetChanges.globalOptions.compareMetrics
              : defaultCompareMetrics
              ? defaultCompareMetrics
              : []
          }
          defaultIncludeOtherDates={
            pagePresetChanges &&
            pagePresetChanges.globalOptions &&
            pagePresetChanges.globalOptions &&
            pagePresetChanges.globalOptions.compareMetricsIncludeOtherDates
              ? pagePresetChanges.globalOptions.compareMetricsIncludeOtherDates
              : false
          }
          dateIncrementOptions={R.map(option => DATE_GROUPING_MAP[option], dateIncrementOptions)}
          defaultDateGroupingKey={
            pagePresetChanges && pagePresetChanges.dateInfo && pagePresetChanges.dateInfo.increments
              ? DATE_GROUPING_MAP[pagePresetChanges.dateInfo.increments]
              : undefined
          }
          metricOptions={compareMetricOptions}
        />
      </div>
    );

    // Only relevant for Linear
    const [liftFromTvDataMap, setLiftFromTvDataMap] = useState({});
    const liftFromTvKey = useMemo(() => {
      if (fetchKPI && dates) {
        return `${fetchKPI}_${dates.start}_${dates.end}`;
      }
    }, [fetchKPI, dates]);

    useEffect(() => {
      (async () => {
        if (prefix === LINEAR && fetchKPI && dates && liftFromTvKey) {
          try {
            const res = await LinearPerformanceLambdaFetch("/getLiftFromTvChart", {
              params: {
                kpi: fetchKPI,
                start: dates.start,
                end: dates.end,
              },
            });
            const data = await awaitJSON(res);
            setLiftFromTvDataMap(map => ({ ...map, [liftFromTvKey]: data }));
          } catch (e) {
            console.error(
              `Failed to fetch lift from TV data for ${company}, ${fetchKey}, ${dates}. Refresh to retry`
            );
          }
        }
      })();
    }, [company, dates, fetchKPI, fetchKey, liftFromTvKey, prefix]);

    const liftFromTvChart = useMemo(() => {
      if (prefix === LINEAR && liftFromTvKey && liftFromTvDataMap[liftFromTvKey]) {
        return <LiftFromTvChart data={liftFromTvDataMap[liftFromTvKey]} fiscalCal={fiscalCal} />;
      }
    }, [liftFromTvDataMap, liftFromTvKey, prefix, fiscalCal]);

    const residentialResponseRates = useMemo(() => {
      if (data) {
        const fetchKey = dataFetchKey({
          audience: fetchAudience,
          kpi: fetchKPI,
          lag: fetchLag,
        });

        let totalResponses = 0;
        let totalResidentialResponses = 0;
        let totalImps = 0;
        let totalResidentialImps = 0;

        for (let item of data.data) {
          if (item.fetches) {
            const obj = item?.fetches[fetchKey];

            if (obj) {
              totalResponses += (obj || {}).resps || 0;
              totalResidentialResponses += (obj || {}).residResps || 0;
              totalImps += (obj || {}).imps || 0;
              totalResidentialImps += (obj || {}).residImps || 0;
            }
          }
        }

        const residentialResponseRate = formatPercent(
          totalResidentialResponses / totalResponses,
          1
        );
        const residentialDeliveryRate = formatPercent(totalResidentialImps / totalImps, 1);

        return {
          residentialResponseRate,
          residentialDeliveryRate,
        };
      }
    }, [data, dataFetchKey, fetchAudience, fetchKPI, fetchLag]);

    // Only relevant for Streaming and Audio
    const conversionLatencyChart = useMemo(() => {
      if ((prefix === STREAMING_PLUS[0] || prefix === STREAMING_PLUS[1]) && fetchKPI && dates) {
        return (
          <div className="conversionLatencyContainer">
            <ConversionLatencyHistogram
              kpi={fetchKPI}
              start={dates.start}
              end={dates.end}
              prefix={prefix as "streaming" | "audio"}
            />
            <MatchableRates residentialResponseRates={residentialResponseRates} />
          </div>
        );
      }
    }, [dates, fetchKPI, prefix, residentialResponseRates]);

    ////////////////////////////
    // METRICS TAB
    ////////////////////////////
    // Check to make sure nothing is missing from the table preset
    const customSegmentColumnMap = useMemo(() => {
      if (!R.isNil(filterData) && !R.isEmpty(filterData)) {
        const customSegments = filterData
          .filter(option => option.isCustomSegment)
          .reduce(
            (curr, prev) => ({
              ...curr,
              [prev.label]: makeColumnMetaData(prev.label as any),
            }),
            {}
          );
        return customSegments;
      }
    }, [filterData]);

    const processedTablePreset: MetricsTablePreset = useMemo(() => {
      const dimensionColumns: DimensionColumn[] = [];
      const dataColumns: Column[] = [];
      if (pagePreset && tablePreset && customSegmentColumnMap && columnMetaDataMap) {
        R.map(oldDimCol => {
          const dimColMetaDataMap = {
            ...dimensionColumnMetaDataMap,
            ...R.defaultTo({}, customSegmentColumnMap),
          };
          const columnMetaData =
            oldDimCol && dimColMetaDataMap[oldDimCol.dimensionTypeName]
              ? dimColMetaDataMap[oldDimCol.dimensionTypeName]
              : dimColMetaDataMap[R.keys(dimColMetaDataMap)[0]];
          if (oldDimCol && R.isNil(dimColMetaDataMap[oldDimCol.dimensionTypeName])) {
            console.error(
              `${oldDimCol.dimensionTypeName} is not present in the dimension column metadata map`
            );
          }
          const newDimCol: DimensionColumn = {
            ...oldDimCol,
            dimensionVarName: columnMetaData.dimensionVarName,
            dimensionTypeName:
              oldDimCol && dimColMetaDataMap[oldDimCol.dimensionTypeName]
                ? oldDimCol.dimensionTypeName
                : R.keys(dimColMetaDataMap)[0],
            label: oldDimCol && oldDimCol.label ? oldDimCol.label : columnMetaData.displayName,
            role: oldDimCol.role ? oldDimCol.role : 10,
            icon:
              oldDimCol.icon !== undefined
                ? oldDimCol.icon
                : columnMetaData.iconStyle
                ? "hasIcon"
                : undefined,
          };
          dimensionColumns.push(newDimCol);
          return oldDimCol;
        }, tablePreset.dimensionColumns);
        R.map(oldDataCol => {
          const columnMetaData =
            oldDataCol && columnMetaDataMap[oldDataCol.dataVarName]
              ? columnMetaDataMap[oldDataCol.dataVarName]
              : columnMetaDataMap[R.keys(columnMetaDataMap)[0]];
          if (oldDataCol && R.isNil(columnMetaDataMap[oldDataCol.dataVarName])) {
            console.error(`${oldDataCol.dataVarName} is not present in the column metadata map`);
          }
          const newDataCol: Column = {
            ...oldDataCol,
            dataVarName:
              oldDataCol && columnMetaDataMap[oldDataCol.dataVarName]
                ? oldDataCol.dataVarName
                : R.keys(columnMetaDataMap)[0],
            label: oldDataCol.label ? oldDataCol.label : columnMetaData.displayName,
            role: oldDataCol.role ? oldDataCol.role : 10,
            kpi: oldDataCol.kpi ? oldDataCol.kpi : fetchKPI,
            lag: oldDataCol.lag ? oldDataCol.lag : fetchLag,
            audience: oldDataCol.audience ? oldDataCol.audience : fetchAudience,
          };
          dataColumns.push(newDataCol);
          return oldDataCol;
        }, tablePreset.dataColumns);
        const processedTablePreset = {
          ...tablePreset,
          dataColumns,
          dimensionColumns,
          globalOptions: {
            ...pagePreset.globalOptions,
            kpi: fetchKPI,
            lag: fetchLag,
            audience: fetchAudience,
          },
        } as any;
        return processedTablePreset;
      }
    }, [
      columnMetaDataMap,
      customSegmentColumnMap,
      dimensionColumnMetaDataMap,
      fetchAudience,
      fetchKPI,
      fetchLag,
      pagePreset,
      tablePreset,
    ]);

    const comparisonPresetToUse = useMemo(() => {
      const result = processedTablePreset;
      if (showMetricsTableComparison) {
        const compPreset = { ...result };
        const newSuperHeaders: SuperHeader[] = compPreset.dataColumns
          ? compPreset.dataColumns.map(col => {
              return {
                data: {
                  text: col.label ? col.label : col.dataVarName,
                  leftDivider: true,
                  rightDivider: true,
                },
                span: 3,
              };
            })
          : [];
        const newDataCols = compPreset.dataColumns
          ? compPreset.dataColumns.reduce((newCols, col) => {
              newCols.push(
                { ...col, label: "primary" },
                { ...col, dataVarName: `${col.dataVarName}_other`, label: "comparison" },
                { ...col, dataVarName: `${col.dataVarName}_delta`, label: "%∆", decimals: 0 }
              );
              return newCols;
            }, [] as Column[])
          : [];
        compPreset.dataColumns = newDataCols;
        compPreset.superHeaders = newSuperHeaders;
        return compPreset;
      }
      return result;
    }, [processedTablePreset, showMetricsTableComparison]);

    const joinedData = useMemo(
      () =>
        data && data.data && otherData && otherData.data && selectedTab === TabKey.METRICS_TABLE
          ? joinMetricsTableData(data.data, otherData.data)
          : undefined,
      [data, otherData, selectedTab]
    );

    // Page Modals
    const editPagePresetModal = (showEditPagePresetModal || showNewPagePresetModal) && (
      <EditPagePresetModal
        dateIncrementOptions={dateIncrementOptions}
        deliveryDimensionMap={deliveryDimensionMap}
        deliveryMetricOptions={deliveryMetricOptions}
        filterPresets={filters}
        pagePresetChanges={pagePresetChanges}
        globalOptionsPickers={{
          audience: prefix === LINEAR ? ([...L.AUDIENCES] as any[]) : undefined,
          kpi: { options: kpiOptions },
          lag: ["audio", "display", "olv", "streaming"].includes(prefix) ? [...S.LAGS] : undefined,
        }}
        groups={pagePresetGroups}
        mediatype={prefix}
        setPagePresetChanges={setPagePresetChanges}
        saveAndApplyOnClick={presetChanges => {
          (async () => {
            if (
              !R.isNil(presetChanges) &&
              !R.isNil(presetChanges.filterInfo) &&
              !R.isNil(presetChanges.filterInfo.filterState)
            ) {
              presetChanges.filterInfo.filterState = filterState;
            }
            await savePagePresetToDB(presetChanges);
            if (
              presetChanges.temporary ||
              (presetChanges.id as any) === "new" ||
              presetChanges.id <= 0 ||
              (pagePreset && presetChanges.id === pagePreset.id)
            ) {
              resetPickers();
            }
            setShowEditPagePresetModal(false);
            setShowNewPagePresetModal(false);
          })();
        }}
        sparkChartOptions={R.keys(sparkChartMetricsMap) as Metric[]}
        tablePresets={R.filter(tablePreset => !tablePreset.temporary, tablePresets)}
        onHide={() => {
          setShowEditPagePresetModal(false);
          setShowNewPagePresetModal(false);
          if (pagePreset) {
            setPagePresetChanges(pagePreset);
          }
        }}
      />
    );

    const renamePagePresetModal = showRenamePagePresetModal && (
      <RenameModal
        applyOnClick={newName => {
          (async () => {
            await savePagePreset({
              company: company,
              id: pagePresetChanges.id,
              mediatype: prefix,
              name: newName,
              group: pagePresetChanges.presetGroup,
            });
            setShowRenamePagePresetModal(false);
            setURL(newName, tablePresetChanges?.name);
          })();
        }}
        applyText={"Save"}
        cancelText={"Discard"}
        disabled={pagePresetChanges.globalOptions.admin_lock && !isAdmin}
        onCancel={() => {
          setShowRenamePagePresetModal(false);
          if (pagePreset) {
            setPagePresetChanges(pagePreset);
          }
        }}
        onHide={() => {
          setShowRenamePagePresetModal(false);
          if (pagePreset) {
            setPagePresetChanges(pagePreset);
          }
        }}
        placeholder="Enter new preset name"
        subTitle={"New Page Preset Name"}
        title={`Rename ${
          pagePresetChanges && pagePresetChanges.name ? pagePresetChanges.name : ""
        }`}
      />
    );

    // Table Modals
    const defaultTablePresetNames = R.map(R.toLower, R.keys(deliveryDimensionMap));
    const editTablePresetModal = (showEditTablePresetModal || showNewTablePresetModal) && (
      <EditTablePresetModal
        columnMetaDataMap={columnMetaDataMap}
        defaultPresetNames={defaultTablePresetNames}
        dimensionColumnMetaDataMap={{
          ...R.defaultTo({}, customSegmentColumnMap),
          ...dimensionColumnMetaDataMap,
        }}
        kpiMetaData={kpiData.kpiMap}
        prefix={prefix}
        onHide={() => {
          setShowEditTablePresetModal(false);
          setShowNewTablePresetModal(false);
          if (tablePreset) {
            setTablePresetChanges(tablePreset);
          }
        }}
        presetChanges={tablePresetChanges}
        refreshCustomMetrics={getCustomMetrics}
        setPresetChanges={setTablePresetChanges}
        saveAndApplyOnClick={tablePreset => {
          (async () => {
            const newID = await saveTablePreset({
              company,
              companyToUseInDB: globalBrand || company,
              id: !R.isNil(tablePreset.id) && tablePreset.id > 0 ? tablePreset.id : "new",
              name: tablePreset.name,
              mediatype: prefix,
              preset: tablePreset,
              temporary: tablePreset.temporary,
            });
            setTablePresetMap(`${newID.id}`, {
              ...tablePresetChanges,
              ...tablePreset,
              name: newID.name,
              id: newID.id,
              temporary: tablePreset.temporary,
            });
            if (
              pagePreset &&
              ((tablePreset.id as any) === "new" ||
                tablePreset.id === tablePresetID ||
                tablePreset.temporary)
            ) {
              const tablePresetName =
                tablePreset.temporary &&
                (R.isNil(tablePreset.id) ||
                  (tablePreset.id as any) === "new" ||
                  tablePreset.id <= 0)
                  ? newID.name
                  : tablePreset.name;
              setURL(pagePreset.name, tablePresetName);
              setDataMap(fetchKey, undefined);
              setDataStatusMap(fetchKey, undefined);
            }
            setShowEditTablePresetModal(false);
            setShowNewTablePresetModal(false);
          })();
        }}
      />
    );
    const renameTablePresetModal = showRenameTablePresetModal && (
      <RenameModal
        applyOnClick={newName => {
          (async () => {
            await saveTablePreset({
              company: company,
              id: tablePresetChanges.id,
              mediatype: prefix,
              name: newName,
              temporary: R.defaultTo(false, tablePresetChanges.temporary),
            });
            const presetInMap = tablePresetMap[`${tablePresetChanges.id}`];
            if (presetInMap) {
              setTablePresetMap(`${tablePresetChanges.id}`, {
                ...presetInMap,
                name: newName,
              });
            }
            if (tablePresetChanges.id === tablePresetID) {
              setTablePresetChanges({ ...tablePresetChanges, name: newName });
            }
            setShowRenameTablePresetModal(false);
            if (pagePreset) {
              setURL(pagePreset.name, newName);
            }
          })();
        }}
        applyText={"Save"}
        cancelText={"Discard"}
        disabled={tablePresetChanges.admin_lock && !isAdmin}
        onCancel={() => {
          setShowRenameTablePresetModal(false);
          if (tablePreset) {
            setTablePresetChanges(tablePreset);
          }
        }}
        onHide={() => {
          setShowRenameTablePresetModal(false);
          if (tablePreset) {
            setTablePresetChanges(tablePreset);
          }
        }}
        placeholder="Enter new preset name"
        subTitle={"New Table Preset Name"}
        title={`Rename ${
          tablePresetChanges && tablePresetChanges.name ? tablePresetChanges.name : ""
        }`}
      />
    );

    // Table Sizing
    const windowResizeFunction = () => setRerenderTable(true);
    if (window && window.onresize !== windowResizeFunction) {
      window.onresize = windowResizeFunction;
    }
    useLayoutEffect(() => {
      const newTableHeight = containerRef.current
        ? (containerRef.current as any).offsetHeight
        : undefined;
      const newTableWidth = containerRef.current
        ? (containerRef.current as any).offsetWidth
        : undefined;
      if (newTableHeight) {
        setTableHeight((containerRef.current as any).offsetHeight);
      }
      if (newTableWidth) {
        setTableWidth((containerRef.current as any).offsetWidth);
      }
      if (rerenderTable) {
        setRerenderTable(false);
      }
    }, [rerenderTable]);

    const metricsTable = useMemo(() => {
      if (data && !rerenderTable && tablePreset && processedTablePreset && customSegmentColumnMap) {
        return showMetricsTableComparison ? (
          joinedData && comparisonPresetToUse && (
            <MetricsTable
              columnMetaDataMap={{
                ...customSegmentColumnMap,
                ...columnMetaDataMap,
                ...dimensionColumnMetaDataMap,
              }}
              data={R.defaultTo([], joinedData) as any}
              dataFetchKey={dataFetchKey}
              exportedData={exportedData}
              filter={filter ? filter.filter : undefined}
              getDimensionCell={getDimensionCell}
              height={tableHeight}
              percentAOIPlaceholder={undefined}
              preset={comparisonPresetToUse as any}
              setExportedData={exportedData => {
                setExportedData(exportedData);
              }}
              width={tableWidth}
              kpiName={pickerKPIName}
            />
          )
        ) : (
          <MetricsTable
            columnMetaDataMap={{
              ...customSegmentColumnMap,
              ...columnMetaDataMap,
              ...dimensionColumnMetaDataMap,
            }}
            data={R.defaultTo([], data.data) as any}
            dataFetchKey={dataFetchKey}
            exportedData={exportedData}
            filter={filter ? filter.filter : undefined}
            getDimensionCell={getDimensionCell}
            height={tableHeight}
            percentAOIPlaceholder={percentAOIPlaceholder}
            preset={processedTablePreset as any}
            setExportedData={exportedData => {
              setExportedData(exportedData);
            }}
            width={tableWidth}
            kpiName={pickerKPIName}
          />
        );
      }
    }, [
      columnMetaDataMap,
      comparisonPresetToUse,
      customSegmentColumnMap,
      data,
      dataFetchKey,
      dimensionColumnMetaDataMap,
      exportedData,
      filter,
      getDimensionCell,
      joinedData,
      percentAOIPlaceholder,
      pickerKPIName,
      processedTablePreset,
      rerenderTable,
      showMetricsTableComparison,
      tableHeight,
      tablePreset,
      tableWidth,
    ]);

    const metricsTableBody = (
      <div className="performance metricsTable" id="performanceContainer" ref={containerRef}>
        {pagePreset &&
        (companyInfo.streaming_performance_default_kpi || pickerKPI) &&
        data &&
        customSegmentColumnMap ? (
          metricsTable
        ) : (
          <PerformanceGridSkeleton />
        )}
      </div>
    );

    const tableFilterBar = (
      <div className="filterBarContainer">
        <FilterBar
          hasAdvanced={false}
          onFilter={filter => {
            setFilter({ filter });
          }}
          options={
            processedTablePreset && processedTablePreset.dimensionColumns
              ? R.map(col => col.dimensionVarName, processedTablePreset.dimensionColumns)
              : []
          }
          size="lg"
          width={770}
        />
      </div>
    );
    const duplicateTablePreset = useCallback(
      preset => {
        (async () => {
          const fullyLoadedPreset =
            preset && !R.isNil(preset.id) && tablePresetMap[`${preset.id}`]
              ? tablePresetMap[`${preset.id}`]
              : await getTablePreset({ id: preset.id, company, mediatype: prefix });
          if (!tablePresetMap[`${preset.id}`] && fullyLoadedPreset) {
            setTablePresetMap(`${preset.id}`, fullyLoadedPreset);
          }
          saveTablePreset({
            company,
            id: "new",
            mediatype: prefix,
            preset: fullyLoadedPreset,
            name: `${preset.name} (Copy)`,
            temporary: R.defaultTo(false, (fullyLoadedPreset as MetricsTablePreset).temporary),
          });
        })();
      },
      [company, getTablePreset, prefix, saveTablePreset, setTablePresetMap, tablePresetMap]
    );

    const tablePresetPicker = (
      <PresetDropdown
        addPresetOnClick={() => {
          setTablePresetChanges(
            changes => ({ ...changes, id: "new", name: "My New Table Preset" } as any)
          );
          setShowNewTablePresetModal(true);
        }}
        addPresetText={"Add New Table Preset"}
        applyOnClick={preset => {
          if (pagePreset) {
            setURL(pagePreset.name, preset.name);
          }
        }}
        cancelOnClick={() => {}}
        className={`tablePresetPicker ${fetchingTablePresets ? "loading" : ""}`}
        defaultPresetNames={defaultTablePresetNames}
        deleteItemOnClick={presetID => deleteTablePreset({ id: presetID, mediatype: prefix })}
        duplicateItemOnClick={preset => duplicateTablePreset(preset)}
        editItemOnClick={preset => {
          (async () => {
            const fetchedTablePreset = (tablePresetMap[`${preset.id}`]
              ? tablePresetMap[`${preset.id}`]
              : await getTablePreset({
                  id: preset.id,
                  company,
                  mediatype: prefix,
                })) as MetricsTablePreset;
            if (!R.isNil(tablePresetMap[`${preset.id}`])) {
              setTablePresetMap(`${preset.id}`, fetchedTablePreset);
            }
            setTablePresetChanges(fetchedTablePreset);
            setShowEditTablePresetModal(true);
          })();
        }}
        hasTicks={true}
        label={
          tablePreset && !R.isNil(tablePreset.id)
            ? `Table Preset: ${tablePreset.temporary ? "Temp" : tablePreset.name}`
            : "Load Table Preset"
        }
        presets={R.filter(
          preset => !preset.temporary || (!R.isNil(tablePreset) && preset.id === tablePreset.id),
          tablePresets
        )}
        renameItemOnClick={(preset: PresetIDGroups) => {
          setTablePresetChanges({ adminLock: preset.admin_lock, id: preset.id } as any);
          setShowRenameTablePresetModal(true);
        }}
        selectedPreset={tablePreset}
      />
    );

    const colorScaleItems: { label: string; style }[] = [
      { label: "", style: { backgroundColor: HeatMappingDivergentNeg3 } },
      { label: "", style: { backgroundColor: HeatMappingDivergentNeg2 } },
      { label: "", style: { backgroundColor: HeatMappingDivergentNeg1 } },
      {
        label: "Avg",
        style: { backgroundColor: HeatMappingDivergent0, outline: "1px solid #BEEB80" },
      },
      { label: "", style: { backgroundColor: HeatMappingDivergentPos1 } },
      { label: "", style: { backgroundColor: HeatMappingDivergentPos2 } },
      { label: "", style: { backgroundColor: HeatMappingDivergentPos3 } },
    ];

    const hasDivergingColorScheme = useMemo(() => {
      if (tablePreset && tablePreset.dataColumns && tablePreset.dataColumns.length) {
        for (const col of tablePreset.dataColumns) {
          if (col && col.heatMapping && col.heatMapping.colorScheme === "diverging") {
            return true;
          }
        }
      }
      return false;
    }, [tablePreset]);

    const colorScale =
      hasDivergingColorScheme &&
      (showColorScale ? (
        <Button
          className="colorScaleButton"
          design="secondary"
          onClick={() => setShowColorScale(false)}
          size={"lg"}
          type={ButtonType.OUTLINED}
          variant={ButtonFrameworkVariant.NO_ICON}
        >
          <div className="colorScale">
            {R.map(
              item => (
                <div style={item.style}>{item.label}</div>
              ),
              colorScaleItems
            )}
          </div>
        </Button>
      ) : (
        <Button
          className="showColorScaleButton"
          design="secondary"
          icon={<ColorScale />}
          onClick={() => setShowColorScale(true)}
          size={"lg"}
          type={ButtonType.OUTLINED}
          variant={ButtonFrameworkVariant.LEADING_ICON}
        >
          See Color Scale
        </Button>
      ));
    const glossaryButton = (
      <Button
        className="glossaryButton"
        design="secondary"
        icon={<MdViewHeadline />}
        onClick={() => setShowGlossary(true)}
        size={"lg"}
        type={ButtonType.FILLED}
        variant={ButtonFrameworkVariant.LEADING_ICON}
      >
        Glossary
      </Button>
    );
    const downloadButton = (
      <div
        onClick={() => {
          const csvContent = R.map(
            e =>
              e
                .map(cell =>
                  typeof cell === "number" ? cell : R.defaultTo("-", cell).replace(/,/g, "")
                )
                .join(","),
            exportedData
          ).join("\n");
          download(csvContent, "Metrics Table.csv", "text/csv");
        }}
      >
        <DownloadToggle />
      </div>
    );

    const glossaryModal = (
      <GlossaryModal
        show={showGlossary}
        setShow={() => setShowGlossary(false)}
        title="Metrics Glossary"
        initialGlossary={glossary}
      />
    );

    const showComparisonButton = (
      <Button
        type={ButtonType.FILLED}
        design="secondary"
        className="showComparisonButton"
        onClick={() => {
          setShowMetricsTableComparison(!showMetricsTableComparison);
          setExportedData([]);
        }}
      >
        {showMetricsTableComparison ? "Hide Comparison" : "Show Comparison"}
      </Button>
    );

    const metricsTableControls = mediaTypeEnabled && (
      <div className="metricsTableControlsContainer">
        {tableFilterBar}
        <div className="metricsTableControls">
          {showComparisonButton}
          {tablePresetPicker}
          {colorScale}
          {glossaryButton}
          {downloadButton}
        </div>
      </div>
    );

    ////////////////////////////
    // DELIVERY TAB
    ////////////////////////////
    const delivery = deliveryData &&
      pagePresetChanges &&
      ((otherDates && otherDeliveryData) || !R.isNil(otherDates)) && (
        <Delivery
          company={company}
          data={deliveryData}
          dates={dates}
          defaultDateGroupingKey={
            pagePresetChanges && pagePresetChanges.dateInfo && pagePresetChanges.dateInfo.increments
              ? DATE_GROUPING_MAP[pagePresetChanges.dateInfo.increments]
              : undefined
          }
          defaultMetric={pagePresetChanges.globalOptions.deliveryMetric}
          deliveryMetricOptions={deliveryMetricOptions}
          dimension={deliveryDimension}
          dimensionOptions={R.keys(deliveryDimensionMap)}
          getDimensionCell={getDimensionCell}
          otherData={otherDeliveryData}
          otherDates={otherDates}
          prefix={prefix}
          setDimension={setDeliveryDimension}
          overviewKeys={defaultDeliveryOverviewMetrics}
        />
      );

    const title =
      prefix === SEARCHSHOPPING
        ? "Search & Shopping"
        : prefix === YOUTUBE
        ? "YouTube"
        : `${prefix.charAt(0).toUpperCase()}${prefix.substring(1)}`;

    return (
      <PerformanceContext.Provider
        value={{
          branchBuild,
          globalBrand: globalBrand,
          globalKpi: fetchKPI,
          globalLag: fetchLag,
          impsBetween: true,
          isGraph,
          kpiMetaData,
          prefix: prefix === LINEAR ? "tv" : prefix,
        }}
      >
        <Page
          actions={actionsContainer}
          app2Redesign
          minWidth="500px"
          navs={NAVS}
          onNav={nav => {
            setSelectedTab(nav);
            if (selectedTab !== nav && nav === TabKey.METRICS_TABLE) {
              setRerenderTable(true);
            }
            if (pagePresetName) {
              const tablePresetName = tablePreset ? tablePreset.name : undefined;
              setURL(pagePresetName, tablePresetName, nav);
            }
          }}
          pageType={title}
          selectedNav={selectedTab}
          subHeader={subHeader}
          title={<div className="performanceTitle">{title}</div>}
        >
          {/* Modals */}
          {glossaryModal}
          {editPagePresetModal}
          {renamePagePresetModal}
          {editTablePresetModal}
          {renameTablePresetModal}
          {!mediaTypeEnabled ? (
            <div className="notAllowed">This company does not support this media type.</div>
          ) : (
            <>
              {/* Overview */}
              {selectedTab === TabKey.OVERVIEW && overviewSparkCharts}
              <div className="overviewBottomRow">
                {selectedTab === TabKey.OVERVIEW && overviewCompareMetricsChart}
                {selectedTab === TabKey.OVERVIEW &&
                  [LINEAR, STREAMING_PLUS[0], STREAMING_PLUS[1]].includes(prefix) &&
                  !loading &&
                  overviewSparkCharts && (
                    <div className="optionalOverviewBottomChart">
                      {selectedTab === TabKey.OVERVIEW && prefix === LINEAR && liftFromTvChart}
                      {selectedTab === TabKey.OVERVIEW &&
                        [STREAMING_PLUS[0], STREAMING_PLUS[1]].includes(prefix) &&
                        conversionLatencyChart}
                    </div>
                  )}
              </div>
              {loading && selectedTab === TabKey.OVERVIEW && <Spinner size={100} />}
              {/* Metrics Table */}
              {selectedTab === TabKey.METRICS_TABLE && metricsTableControls}
              {selectedTab === TabKey.METRICS_TABLE && metricsTableBody}
              {loading && selectedTab === TabKey.METRICS_TABLE && <PerformanceGridSkeleton />}
              {/* Delivery */}
              {selectedTab === TabKey.DELIVERY && delivery}
              {loading && selectedTab === TabKey.DELIVERY && <Spinner size={100} />}
              {/* Save */}
              {saving && <FullPageSpinner transparent fixed />}
            </>
          )}
        </Page>
      </PerformanceContext.Provider>
    );
  }
);

export default SingleChannelPage;
